import React, { Component } from 'react';
import * as sideBarActions from '../../redux/sideBarActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { string } from '../../localization';
import Draggable from 'react-draggable';
import './WarningView.scss';

class OrderSampleWindow extends Component {
  handleOrderNow = () => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.showRequestSampleWindow(false);
    dispatchers.fabricCanvasActions.showOrderSampleDetailsWindow(true);
  };

  render() {
    const { dispatchers } = this.props;

    return (
      <Draggable defaultPostion={{ x: '50%', y: '50%' }}>
        <div className='order-sample-window'>
          <div style={{ marginBottom: '20px' }}>
            {string.ORDER_SAMPLE_KEY}
            <button
              type='button'
              style={{ border: 'none', outline: 'none' }}
              aria-label='close'
              className='order-closeIcon'
              onClick={() => {
                dispatchers.fabricCanvasActions.showRequestSampleWindow(false);
                dispatchers.fabricCanvasActions.setSendPreviewWithLoupe(false);
              }}
            />
          </div>

          <div>
            <p>{string.ORDER_SAMPLE_INFOLABEL_1}</p>
            <p className='greyedText'>{string.ORDER_SAMPLE_INFOLABEL_2}</p>
            <p className='greyedText'>{string.ORDER_SAMPLE_INFOLABEL_3}</p>
          </div>

          <div className='d-flex order-sample-button'>
            <button
              type='button'
              className='btn btn-primary'
              style={{
                width: '100%',
                height: 'fit-content',
                float: 'center',
                marginTop: '40px'
              }}
              onClick={this.handleOrderNow}
            >
              {string.ORDER_SAMPLE_NOW_BUTTON_TITLE}
            </button>
          </div>
          <div className='d-flex order-sample-button'>
            <button
              type='button'
              className='btn cancel-btn'
              onClick={() => {
                dispatchers.fabricCanvasActions.showRequestSampleWindow(false);
                dispatchers.fabricCanvasActions.setSendPreviewWithLoupe(false);
              }}
            >
              {string.CANCEL_TEXT_KEY}
            </button>
          </div>
        </div>
      </Draggable>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderSampleWindow);
